<cdk-virtual-scroll-viewport #searchScroller itemSize="28" class="list-recent">
  <mat-list class="styled">
    <mat-list-item [title]="search.keywords" (click)="onSearchItemClick(search)"
                   *cdkVirtualFor="let search of recentSearches"
                   class="recent-menu-item">
      <div class="div-recent" title="">
        <div class="text-ellipsis recent-item-val" title="{{getTooltip(search)}}">
          <span class="link-underscore" title="{{getTooltip(search)}}">
          <ng-template [ngIf]="search.state && search.state.stateAbbr">({{search.state.stateAbbr}}) </ng-template>
          <ng-template [ngIf]="search.keywords">{{search.keywords}}</ng-template>
          <ng-template [ngIf]="search.cusip">{{search.cusip}}</ng-template>
          </span>
        </div>
        <div class="recent-item-date" title="{{getTooltip(search)}}">
          <span>{{search.dateCreated | date : 'MM/dd/yyyy'}}</span>
        </div>
      </div>
    </mat-list-item>
    <div class="spinner-item" *ngIf="searchLoading">
      <mat-progress-spinner [mode]="'indeterminate'" [diameter]="50"></mat-progress-spinner>
    </div>
  </mat-list>
</cdk-virtual-scroll-viewport>
